import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Card from '@/src/components/Card';
import { RatingReview } from '@/interfaces/Rating';
import RatingHeadline from './RatingHeadline';

const RatingDescription = styled.article`
  padding: 0.5rem 1rem 1.5rem;
`;

const RatingTitle = styled.span`
  font-weight: bold;
  margin: 0 0 0.5rem;
  display: block;
`;

const ReviewTags = styled.div`
  margin-top: 0.5rem;
`;

interface RatingCardProps {
  rating: RatingReview;
  showMenu?: boolean;
}

export const RatingCard: FunctionComponent<RatingCardProps> = ({
  rating,
  showMenu = true,
}): ReactElement => (
  <Card
    data-testid="rating"
    key={rating.id}
    headline={<RatingHeadline menu={showMenu} rating={rating} />}
  >
    <RatingDescription>
      {rating.title && rating.title !== '' && (
        <RatingTitle data-testid="rating-card-title">{rating.title}</RatingTitle>
      )}
      <div data-testid="rating-review-description">{rating.description}</div>
      {rating.reviewTags && rating.reviewTags.proTags && (
        <ReviewTags data-testid="rating-card-pro-tags">
          <strong>
            <FormattedMessage id="rating.labels.pro" defaultMessage="Vorteile: " />
          </strong>
          {rating.reviewTags.proTags.map((tag, index) =>
            index < rating.reviewTags.proTags.length - 1 ? `${tag.name}, ` : tag.name,
          )}
        </ReviewTags>
      )}
      {rating.reviewTags && rating.reviewTags.contraTags && (
        <ReviewTags data-testid="rating-card-contra-tags">
          <strong>
            <FormattedMessage id="rating.labels.contra" defaultMessage="Nachteile: " />
          </strong>
          {rating.reviewTags.contraTags.map((tag, index) =>
            index < rating.reviewTags.contraTags.length - 1 ? `${tag.name}, ` : tag.name,
          )}
        </ReviewTags>
      )}
    </RatingDescription>
  </Card>
);

export default RatingCard;
